import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 * Passes on the KeyCloak token
 */
export const accessTokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);

  return from(authenticationService.getAccessToken())
    .pipe(
      switchMap(authToken => {
        if (!authToken) {
          return next(request);
        }
        const clone = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + authToken
          }
        });
        return next(clone);
      })
    );
}
